import React, { useState } from 'react';
import MainImage from '../../images/portfolio/Berserk/video-thumbnail.png';
import PortfolioPage from '../../components/PortfolioPage';
import { StaticImage } from 'gatsby-plugin-image';
import { useT } from '../../i18n';

const Berserk = () => {
    const t = useT();
    return <PortfolioPage
        img={MainImage}
        url="https://player.vimeo.com/video/1057114933"
        title="Berserk - The Branch & To Små Bulgarere"
        description={t(<div>
          <p>
            Vikinger: Forferdelige, brutale skapninger som plyndrer og dreper. Nå som de har et hemmelig våpen, blir de bare enda mer blodtørstige. Hva er det disse sopp-etende, villmennene har funnet på nå da?
          </p>
          <br />
          <p>
            (2025)
          </p>
          <br />
          <p>
            ‘Berserk’ er en musikkvideo i samarbeid med musikkduoen To Små Bulgarere. Samarbeidet kom til da vi tenkte de artige ideene til Øystein Dolmen og Jovan Pavlovic passet perfekt med vår lidenskap for underholdende og levende animasjonsstil. Filmen ble støttet av Midtnorsk Filmsenter, Trondheim kommune og Fond for lyd og bilde, og hadde premiere på kortfilmfestivalen i Grimstad 2025.
          </p>
          <div className="mt-16">
            <p>INFO</p>
            <ul className='list-disc pl-4 mt-2'>
              <li>Lengde 03:46</li>
              <li>Språk: Norsk</li>
              <li>Regi og animasjon: The Branch</li>
              <li>Sang ‘Berserk’ av To Små Bulgarere</li>
              <li>Produsent: Peter A. Clayborough</li>
              <li>Bakgrunner: Magne Skagen</li>
              <li>Compositing: Audun A. E. Løkås</li>
              <li>Med: Øystein Dolmen og Jovan Pavlovic</li>
              <li>Lyddesign og miks: Katarzyna Maria Wieczorek</li>
            </ul>
          </div>
        </div>,
        <div>
          <p>
            Vikings: Terrible, brutal creatures who plunder and kill. Now that they have a secret weapon, they are even more bloodthirsty. What have these mushroom-eating savages come up with this time?
          </p>
          <br />
          <p>
            (2025)
          </p>
          <br />
          <p>
            ‘Berserk’ is a music video made in collaboration with the music duo To Små Bulgarere. The collaboration came about because we felt that Øystein Dolmen and Jovan Pavlovic's funny ideas were a perfect match for our passion for an entertaining and lively animation style. The film was supported by the Mid-Norway Film Centre (Midtnorsk Filmsenter), Trondheim Municipality and Fond for lyd og bilde, and premiered at the Norwegian Short Film Festival in Grimstad in 2025.
          </p>
          <div className="mt-16">
            <p>INFO</p>
            <ul className='list-disc pl-4 mt-2'>
              <li>Length: 03:46</li>
              <li>Language: Norwegian</li>
              <li>Direction and animation: The Branch</li>
              <li>Song ‘Berserk’ by To Små Bulgarere</li>
              <li>Producer: Peter A. Clayborough</li>
              <li>Backgrounds: Magne Skagen</li>
              <li>Compositing: Audun A. E. Løkås</li>
              <li>Starring: Øystein Dolmen and Jovan Pavlovic</li>
              <li>Sound design and mix: Katarzyna Maria Wieczorek</li>
            </ul>
          </div>
        </div>)}
    >
        <div className="flex  justify-center mt-32 lg:px-0 flex-wrap mb-12">
          <StaticImage src="../../images/portfolio/Berserk/1-artwork.png" />
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/2-artwork.png" />
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/3-artwork.png" />
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/4-artwork.png" />
          <StaticImage className="mt-32" src="../../images/portfolio/Berserk/5-artwork.png" />
        </div>
    </PortfolioPage>

}

export default Berserk;
